import { createTheme, ThemeOptions, Theme } from "@mui/material/styles";
import { PaletteOptions } from "@mui/material/styles/createPalette";

// Declare module augmentation for custom colors/properties if needed
declare module "@mui/material/styles" {
  interface PaletteOptions {
    // Add any custom colors you want to define
    customColor?: {
      main: string;
      light?: string;
      dark?: string;
      contrastText?: string;
    };
  }
  interface Palette {
    customColor?: {
      main: string;
      light: string;
      dark: string;
      contrastText: string;
    };
  }
}

const palette: PaletteOptions = {
  primary: {
    main: "#3D68FF",
    light: "#42a5f5",
    dark: "#1565c0",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#9c27b0",
    light: "#ba68c8",
    dark: "#7b1fa2",
    contrastText: "#ffffff",
  },
  error: {
    main: "#d32f2f",
  },
  warning: {
    main: "#ed6c02",
  },
  info: {
    main: "#0288d1",
  },
  success: {
    main: "#2e7d32",
  },
  background: {
    default: "#ffffff",
    paper: "#f5f5f5",
  },
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
};

const themeOptions: ThemeOptions = {
  palette,
  // Add other theme customizations here
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
    },
    // Add more typography options as needed
  },
};

const theme: Theme = createTheme(themeOptions);

export default theme;
